import i18next from 'i18next'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { globalOnDemandVars } from '../../../../helper/context'
import { copyTextToClipBoard, showToastByMenuDirection, truncateDefault } from '../../../../helper/functions'
import { Button, ButtonGroup, Card, EditableText, Popover, Tooltip } from '@blueprintjs/core'
import { hasScrollbarAlways, hasScrollbarIfHover } from '../../../../helper/CSSclasses'
import { OverlayProps } from '../../../../helper/configs'
import { InsertFormArray } from './forEachInsertForm/insertFormRegister'
import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import { ImageClass, widgetStyles } from './forEachInsertForm/imageHelp'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import DialogComp from '../../../commonInterface/dialog'
import { useTranslation } from 'react-i18next'
import ThumbNail from './forEachInsertForm/thumbnail'

export function OneItemForType1 ({ item, dragHandleProps, setDialog, location, firstWaitingItem }) {
  const ClassForType = useMemo(() => (InsertFormArray.find((oneClass) => (oneClass.type === item.type))), [item.type])

  const [title, setTitle] = useState(item.title)
  useEffect(() => {
    if (title !== item.title) {
      setTitle(item.title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.title])
  useEffect(() => {
    item.setSetTitleForType1Item(setTitle)
    return () => {
      item.setSetTitleForType1Item(null)
    }
  }, [item])

  const onConfirm = useCallback(
    (newValue) => {
      let currentIndex, newList
      switch (location) {
        case 'waiting':
          currentIndex = globalOnDemandVars.waitingItemsForType1().findIndex((maybeItem) => (maybeItem.id === item.id))
          newList = Array.from(globalOnDemandVars.waitingItemsForType1())
          newList[currentIndex].setTitle(newValue)
          globalOnDemandVars.set_waitingItemsForType1(newList)
          break
        case 'used':
          currentIndex = globalOnDemandVars.usedItemsForType1().findIndex((maybeItem) => (maybeItem.id === item.id))
          newList = Array.from(globalOnDemandVars.usedItemsForType1())
          newList[currentIndex].setTitle(newValue)
          globalOnDemandVars.set_usedItemsForType1(newList)
          break
        default:
          break
      }
    }
    ,
    [item.id, location]
  )
  const onClickForDelete = useCallback(
    () => {
      updateMediaItemF(item.globalId, {
        inWaitingItemsForType1: false,
        inUsedItemsForType1: false
      })
      let currentIndex, newList
      switch (location) {
        case 'waiting':
          currentIndex = globalOnDemandVars.waitingItemsForType1().findIndex((maybeItem) => (maybeItem.id === item.id))
          newList = Array.from(globalOnDemandVars.waitingItemsForType1())
          newList.splice(currentIndex, 1)
          globalOnDemandVars.set_waitingItemsForType1(newList)
          break
        case 'used':
          currentIndex = globalOnDemandVars.usedItemsForType1().findIndex((maybeItem) => (maybeItem.id === item.id))
          newList = Array.from(globalOnDemandVars.usedItemsForType1())
          newList.splice(currentIndex, 1)
          globalOnDemandVars.set_usedItemsForType1(newList)
          break
        default:
          break
      }
      showToastByMenuDirection({
        message: `${truncateDefault(title)} in Type1 deleted`,
        icon: 'trash',
        action: {
          text: 'Undo',
          onClick: () => {
            let newList
            switch (location) {
              case 'waiting':
                newList = Array.from(globalOnDemandVars.waitingItemsForType1())
                newList.splice(currentIndex, 0, item)
                globalOnDemandVars.set_waitingItemsForType1(newList)
                break
              case 'used':
                newList = Array.from(globalOnDemandVars.usedItemsForType1())
                newList.splice(currentIndex, 0, item)
                globalOnDemandVars.set_usedItemsForType1(newList)
                break
              default:
                break
            }
          }
        }
      })
    }
    ,
    [item, location, title]
  )

  const onExport = useCallback(
    () => {
      copyTextToClipBoard(`![${item.type}](${item.backId})`).then(() => {
        if (location === 'waiting') {
          const waitingItems = globalOnDemandVars.waitingItemsForType1()
          const setWaitingItems = globalOnDemandVars.set_waitingItemsForType1
          const usedItems = globalOnDemandVars.usedItemsForType1()
          const setUsedItems = globalOnDemandVars.set_usedItemsForType1

          const currentIndex = waitingItems.findIndex((maybeItem) => (maybeItem.id === item.id))
          const nextWaitingItems = Array.from(waitingItems)
          nextWaitingItems.splice(currentIndex, 1)

          const nextUsedItems = Array.from(usedItems)
          nextUsedItems.unshift(item)
          updateMediaItemF(item.globalId, {
            inWaitingItemsForType1: false,
            inUsedItemsForType1: true,
            type1Order: 0
          })

          setWaitingItems(nextWaitingItems)
          setUsedItems(nextUsedItems)
        }
        showToastByMenuDirection({
          message: i18next.t('itemCopied', { itemName: truncateDefault(item.title) }),
          intent: 'success',
          icon: 'clipboard'
        })
      })
    }
    ,
    [item, location]
  )

  const [cropChange, setCropChange] = useState(null)
  const [currentCrop, setCurrentCrop] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [cropURL, setCropURL] = useState('')
  const onEditButton = useCallback(
    () => {
      const ImageClassInstance = item.content
      // const ImageURL = `https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`
      setCropURL(`https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`)
      if (ImageClassInstance.cropConfig) {
        setCropChange({
          unit: '%',
          width: ImageClassInstance.cropConfig.width * 100,
          height: ImageClassInstance.cropConfig.height * 100,
          x: ImageClassInstance.cropConfig.x * 100,
          y: ImageClassInstance.cropConfig.y * 100
        })
      }
      setDialogOpen(true)
      //
      // globalOnDemandVars.openGlobalDialog()('Edit Image', (
      //   <div>
      //     <div css={css`max-width: 98%; max-height: 90%; overflow: auto; margin: auto;`}>
      //       <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }} onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={ImageURL} />
      //     </div>
      //     <Button css={css`float: right; position: relative; right: 5px; top: 10px;`} text={'Save & Close'} intent={'primary'} onClick={async () => {
      //       if (currentCrop) {
      //         const newImageClassInstance = new ImageClass(ImageClassInstance.name, ImageClassInstance.publicId, currentCrop.width / 100, currentCrop.height / 100, {
      //           x: currentCrop.x / 100,
      //           y: currentCrop.y / 100
      //         })
      //         item.setContent(newImageClassInstance)
      //         if (item.globalId) {
      //           await updateMediaItemF(item.globalId, {
      //             content: JSON.stringify(newImageClassInstance)
      //           })
      //         }
      //         showToastByMenuDirection({
      //           message: `'${truncateDefault(ImageClassInstance.name)}' saved`,
      //           intent: 'primary',
      //           icon: 'saved'
      //         })
      //       }
      //
      //       globalOnDemandVars.closeGlobalDialog()()
      //     }} />
      //   </div>
      // ), 'bigger')

      //
      // const transformWidget = cloudinary.createUploadWidget({
      //   cloudName: 'learnobit',
      //   uploadPreset: 'nfcv1f2k',
      //   publicId: ImageClassInstance.publicId,
      //   autoMinimize: true,
      //   cropping: true,
      //   showSkipCropButton: false,
      //   theme: 'minimal',
      //   styles: widgetStyles
      // }, (error, result) => {
      //   if (process.env.NODE_ENV !== 'production') {
      //     console.tron.display({
      //       name: 'cloudinary callback / transform',
      //       value: {
      //         error, result
      //       }
      //       // , important: true
      //     })
      //   }
      //   if (result && result.event === 'queues-end') {
      //     const files = result.info.files
      //     if (files.length > 1) {
      //       throw (new Error('multiple files'))
      //     }
      //
      //     const transformedImageClasses = files.map((file) => {
      //       if (file.status === 'success') {
      //         return new ImageClass(ImageClassInstance.name, file.uploadInfo.public_id, file.customCoordinates.width, file.customCoordinates.height, file.customCoordinates)
      //       } else {
      //         return undefined
      //       }
      //     })
      //
      //     if (transformedImageClasses[0]) {
      //       item.setContent(transformedImageClasses[0])
      //       if (item.globalId) {
      //         updateMediaItemF(item.globalId, {
      //           content: JSON.stringify(transformedImageClasses[0])
      //         })
      //       }
      //       showToastByMenuDirection({
      //         message: `'${truncateDefault(ImageClassInstance.name)}' saved`,
      //         intent: 'primary',
      //         icon: 'saved'
      //       })
      //     }
      //   }
      // })
      //
      // transformWidget.open(null, { files: [`https://res.cloudinary.com/learnobit/image/upload/${ImageClassInstance.publicId}`] })
    },
    [item]
  )

  const { t } = useTranslation()

  const card = useMemo(() => (<React.Fragment>
    <Card elevation={2} interactive title={title} css={css`
  position: relative;
  cursor: default !important; justify-content: flex-start;
  overflow-x: auto;
  border: var(--primary3) 1px solid;
  ${firstWaitingItem
      ? 'box-shadow: 0 0 0 1px rgba(15, 153, 96, 0.1), 0 1px 1px rgba(15, 153, 96, 0.2), 0 2px 6px rgba(15, 153, 96, 0.2) !important;' +
    'border-color: #0F9960 !important;' : ''};
  padding: 0; margin-bottom: 5px;
  display: flex;
  & .visibleIfHover {
    visibility: hidden;
  }
  &:hover .visibleIfHover {
    visibility: visible;
  }
  `} className={hasScrollbarIfHover}>
      <div className={'bp3-button bp3-icon-drag-handle-vertical bp3-minimal visibleIfHover'} {...dragHandleProps} />
      <EditableText css={css`flex: auto; margin: auto 0 auto 0; overflow: hidden; line-height: 18px !important;
// TODO 알 수 없는 이유로 edit mode 에서 모든 text 를 다 지웠을 때 height 과 line-height 이 거의 inf 값이 돼버림(이거랑 비슷한 oneItemForInsertForm 에서는 안그런다는게 이상한점)
& span, input {
  max-height: 18px !important;
  line-height: 18px !important;
}
`} confirmOnEnterKey
        spellCheck={false}
        value={title} onChange={setTitle} onConfirm={onConfirm} />
      {/* <span css={css`flex: auto; font-weight: bold; margin: auto 0 auto 0; overflow: hidden;`}>{title}</span> */}
      <span css={css`width: 90px;`} />
      <ButtonGroup minimal className={'visibleIfHover'} css={css`position: absolute; right: 0;`}>
        <Tooltip {...OverlayProps} position='top' content={'Copy to the clipboard'} intent={'success'}><Button
          icon={'clipboard'} intent='success' onClick={onExport} /></Tooltip>
        <Popover {...OverlayProps} canEscapeKeyClose={false} interactionKind='hover-target' position='top'
          content={<div css={css`width: 100px;`}><ThumbNail item={item} /></div>}>
          <Button icon={'edit'} title={t('Edit')} onClick={onEditButton} />
        </Popover>
        <Button icon={'trash'} title={t('Delete')} onClick={onClickForDelete} />
      </ButtonGroup>
    </Card>
    <DialogComp isOpen={dialogOpen} setDialogOpen={setDialogOpen} title={t('editImage')} type={'bigger'}>
      <React.Fragment>
        <div css={css`max-width: 98%; max-height: 90%; overflow: auto; margin: auto;`}>
          <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }} onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={cropURL} />
        </div>
        <Button css={css`float: right; position: relative; right: 5px; top: 10px;`} text={t('Save & Close')} intent={'primary'} onClick={async () => {
          const ImageClassInstance = item.content
          if (currentCrop) {
            const newImageClassInstance = new ImageClass(ImageClassInstance.name, ImageClassInstance.publicId, ImageClassInstance.width, ImageClassInstance.height, {
              width: currentCrop.width / 100,
              height: currentCrop.height / 100,
              x: currentCrop.x / 100,
              y: currentCrop.y / 100
            })
            item.setContent(newImageClassInstance)
            if (item.globalId) {
              await updateMediaItemF(item.globalId, {
                content: JSON.stringify(newImageClassInstance)
              })
            }
            showToastByMenuDirection({
              message: i18next.t('mediaSaved', { mediaName: truncateDefault(newImageClassInstance.name) }),
              intent: 'primary',
              icon: 'saved'
            })
          }

          setDialogOpen(false)
        }} />
      </React.Fragment>
    </DialogComp>
  </React.Fragment>), [cropChange, cropURL, currentCrop, dialogOpen, dragHandleProps, firstWaitingItem, item, onClickForDelete, onConfirm, onEditButton, onExport, title])

  return (
    firstWaitingItem ? (
      <Tooltip {...OverlayProps} content={t('Pressing alt + 1 in a node will insert this item')} intent={'success'} targetTagName={'div'}>{card}</Tooltip>
    ) : card
  )
}
